// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"22390083","453":"42c646c7"}[chunkId] + ".chunk.js";
};